import { render } from "./NotFound.vue?vue&type=template&id=5c90f389"
const script = {}

import exportComponent from "/home/chris/tw/src/attendctrl/attend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__